import { useState as t } from "react";
import { useIsomorphicLayoutEffect as n } from "./use-isomorphic-layout-effect.js";
const l = () => {
  const [e, r] = t(0);
  return n(() => {
    if (typeof window > "u") return;
    const o = () => {
      r(window.scrollY);
    };
    return o(), window.addEventListener("scroll", o), () => {
      window.removeEventListener("scroll", o);
    };
  }, []), e;
};
export {
  l as useScrollPosition
};
